// extracted by mini-css-extract-plugin
export default {"congratulateBlock":"Complete_congratulateBlock__dR1jd","error":"Complete_error__-+p1G"};